import React from 'react';
import { Container, Paper } from '@mui/material';
import UserGuide from './UserGuide';

const DocumentationPage: React.FC = () => {
  return (
    <Container maxWidth="lg">
      <Paper elevation={3} sx={{ 
        bgcolor: 'background.paper',
        borderRadius: 1,
        overflow: 'hidden',
        p: 0
      }}>
        <UserGuide />
      </Paper>
    </Container>
  );
};

export default DocumentationPage; 